import { render, staticRenderFns } from "./StopeTrackerBoard.vue?vue&type=template&id=f2e6d732&"
import script from "./StopeTrackerBoard.vue?vue&type=script&lang=ts&"
export * from "./StopeTrackerBoard.vue?vue&type=script&lang=ts&"
import style0 from "./StopeTrackerBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VIcon,VTooltip})
